<template>
  <HomePage
    @on-search="addToSearchHistory"
    @on-clear-search-history="clearHistory()"
    @on-remove-search-item="removeItemFromHistoryList"
    @onSearchinput="getSearchListApi($event)"
    @onClearLocationHistory="clearHistory('loc_hst')"
    @onRemoveLocationItem="removeItemFromHistoryList($event, 'loc_hst')"
    @onLocationinput="fetchLocations($event)"
    :searchListHistory="searchListHistory"
    :searchListApi="searchListApi"
    :locationListHistory="locationListHistory"
    :locationListApi="locationListApi"
  />
</template>

<script>
import { inject, provide, ref } from 'vue';
import HomePage from '@/components/homePage/HomePage.component.vue';
import { useLocations } from '@/hooks/autocomplete.hook';
import GeolocationHook from '@/hooks/geoLocation.hook';
import { LocalStoragePlugin } from '@/plugins';
import { HomeService, SuggestionSearchService } from '@/services';

export default {
  components: {
    HomePage,
  },
  setup() {
    const searchListHistory = ref(
      (LocalStoragePlugin.get('text_hst_d9')?.split('|') || []).filter((elem) => !!elem).reverse().map(decodeURI),
    );

    const locationListHistory = ref(
      (LocalStoragePlugin.get('loc_hst')?.split('|') || []).filter((elem) => !!elem).reverse().map(decodeURI),
    );
    function refreshHistory(key = 'text_hst_d9') {
      if (key === 'text_hst_d9') {
        searchListHistory.value = (LocalStoragePlugin.get(key)?.split('|') || []).filter((elem) => !!elem).reverse().map(decodeURI);
      } else {
        locationListHistory.value = (LocalStoragePlugin.get(key)?.split('|') || []).filter((elem) => !!elem).reverse().map(decodeURI);
      }
    }

    function saveItemToLocalStorage(key, value) {
      const listSearchItems = LocalStoragePlugin.get(key)?.split('|') || [];
      const searchAlreadyExist = listSearchItems.indexOf(value);
      if (searchAlreadyExist !== -1) listSearchItems.splice(searchAlreadyExist, 1);
      if (value) { listSearchItems.push(value); }
      LocalStoragePlugin.set(key, listSearchItems.join('|'));
      refreshHistory(key);
    }

    const isExternalMode = inject('isExternalMode');
    function addToSearchHistory({ searchText, locationText }) {
      saveItemToLocalStorage('text_hst_d9', searchText);
      saveItemToLocalStorage('loc_hst', locationText);
      const hasLocation = locationText ? `&loc=${locationText}` : '';
      const { currentPath } = SuggestionSearchService.getDefaultSearchParams();
      let prfixPath = '';
      if (currentPath.includes('s-informer')) {
        prfixPath = '/info';
      } else if (currentPath.includes('trouver')) {
        prfixPath = '/find';
      } else if (prfixPath === '' && currentPath.includes('searchengine')) {
        prfixPath = '/info';
      }
      const urlToredirect = `/recherche${prfixPath}?text=${searchText}${hasLocation}`;
      if (isExternalMode) {
        window.open(urlToredirect, '_blank');
      } else {
        window.location = urlToredirect;
      }
    }

    function clearHistory(key = 'text_hst_d9') {
      LocalStoragePlugin.clear(key);
      refreshHistory(key);
    }
    function removeItemFromHistoryList(key, index = 'text_hst_d9') {
      const listSearchItems = LocalStoragePlugin.get(index)?.split('|') || [];
      const indexItemToremove = listSearchItems?.findIndex(
        (val) => key === val,
      );
      if (indexItemToremove !== -1) { listSearchItems.splice(indexItemToremove, 1); }
      if (listSearchItems.length < 1) {
        clearHistory(index);
      } else {
        LocalStoragePlugin.set(index, listSearchItems.join('|'));
      }
      refreshHistory(index);
    }
    const { getRegionTid } = GeolocationHook();
    const searchListApi = ref([]);
    async function getSearchListApi(key) {
      const { region_id: regionId } = getRegionTid();
      searchListApi.value = await SuggestionSearchService.findSuggestionSearchByKey(key, regionId);
    }

    const searchPlaceholders = HomeService.getPlaceholders();
    provide('searchPlaceholders', searchPlaceholders);

    const [locationListApi, fetchLocations] = useLocations();
    const { where, what } = SuggestionSearchService.getDefaultSearchParams();
    provide('where', where);
    provide('what', what);
    return {
      addToSearchHistory,
      locationListHistory,
      clearHistory,
      removeItemFromHistoryList,
      searchListHistory,
      searchListApi,
      getSearchListApi,
      locationListApi,
      fetchLocations,
    };
  },
};
</script>
